import React from 'react';

const DataCenter: React.FC = () => (
  <div>
    <h1>Docs</h1>
  </div>
);

export default DataCenter;
